module.exports = __webpack_public_path__ + "static/media/animal-sealion1.9516d7f5.aac";